export const ROLE_OPERATOR = "Operator";
export const ROLE_TIPOLOGIA_SEDE = "perfmonTagRole";

export const RESOURCE_ACCESS_PORTALE_GA = "portale-ga";
export const RESOURCE_ACCESS_TIPOLOGIA_SEDE = "perfmontag";